import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";

export const NoComputan = ({ onCambio }) => {
  const [d, setD] = useState(null);
  const [nuevo, setNuevo] = useState("");
  const cargar = () => api.get("/carga-central/no-computan").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { cargar(); }, []);
  const guardar = async (lista) => {
    try { const r = await api.post("/carga-central/no-computan", { lista }); setD((x) => ({ ...x, lista: r.data.lista })); toast.success(`Lista guardada · ${r.data.remarcadas} filas recalculadas`); onCambio?.(); }
    catch { toast.error("No se pudo guardar"); }
  };
  if (!d) return null;
  return (
    <div className="cc-lista" data-testid="cc-no-computan" style={{ padding: "12px 18px" }}>
      <p className="text-sm" style={{ color: "#5B6858", margin: "0 0 10px" }}>No suman en ningún total, ranking ni meta (sí en "Fuera de la meta"). También quedan fuera los vendedores {d.vendedores.join(", ")} y las observaciones {d.observaciones.join(" / ")}.</p>
      <div className="flex flex-wrap gap-2">
        {d.lista.map((c) => <span key={c} className="cc-pill" style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 12px", fontSize: 12 }}>{c}<button aria-label={`Quitar ${c}`} data-testid="cc-nc-quitar" onClick={() => guardar(d.lista.filter((x) => x !== c))} style={{ border: 0, background: "transparent", cursor: "pointer", display: "flex" }}><X className="h-3 w-3" /></button></span>)}
      </div>
      <div className="flex gap-2 mt-3">
        <input className="cc-nc-input" data-testid="cc-nc-input" placeholder="Nombre exacto del cliente (como figura en el listado)" value={nuevo} onChange={(e) => setNuevo(e.target.value)} style={{ flex: 1, height: 40, borderRadius: 12, border: "1px solid #D9E3D6", padding: "0 12px", fontFamily: "inherit" }} />
        <button className="cc-btn verde" style={{ minHeight: 40 }} disabled={!nuevo.trim()} onClick={() => { guardar([...d.lista, nuevo.trim().toUpperCase()]); setNuevo(""); }} data-testid="cc-nc-agregar">Agregar</button>
      </div>
    </div>
  );
};
